<div *ngIf="isFacilityConfigured" class="container-fluid admin-container mb-5 ">
    <div class="row">
        <div class="col-md-12">
            <div class="page-header">
                <div class="mb-4">
                    <p class="page-title">{{resourceKeyValue.prefixSuffixTitle}}</p>
                </div>
            </div>
        </div>
    </div>
    <form content [formGroup]="prefixSuffixForm" (ngSubmit)="addUpdatePrefixSuffix()" id="prefixSuffixForm" class="row">
        <div class="col-md-3">
            <h3 class="mb-3"><strong>{{resourceKeyValue.scannerTitle}}</strong></h3>
            <div class="form-group">
                <label for="scannerPrefix">{{resourceKeyValue.prefix}}</label>
                <input type="text" class="form-control" id="scannerPrefix"
                    placeholder="{{resourceKeyValue.phScannerPrefix}}" formControlName="scannerPrefix"
                    [class.is-invalid]="prefixSuffixForm.controls.scannerPrefix.invalid && prefixSuffixForm.controls.scannerPrefix.dirty">
                <div class="invalid-feedback"
                    *ngIf="prefixSuffixForm.controls.scannerPrefix.invalid && prefixSuffixForm.controls.scannerPrefix.dirty"
                    id="scannerPrefix-validation">
                    <small
                        *ngIf="prefixSuffixForm.controls.scannerPrefix.errors?.onlyWhiteSpace">{{resourceKeyValue.onlyWhiteSpaceNotAllowed}}</small>
                    <small
                        *ngIf="prefixSuffixForm.controls.scannerPrefix.errors.maxlength">{{resourceKeyValue.validationLengthMustbe50Characters}}</small>
                    <small
                        *ngIf="prefixSuffixForm.controls.scannerPrefix.errors?.containsWhiteSpace">{{resourceKeyValue.whiteSpaceNotAllowed}}</small>
                </div>
            </div>
            <div class="form-group">
                <label for="scannerSufffix">{{resourceKeyValue.suffix}}</label>
                <input type="text" class="form-control" id="scannerSufffix"
                    placeholder="{{resourceKeyValue.phScannerSuffix}}" formControlName="scannerSufffix"
                    [class.is-invalid]="prefixSuffixForm.controls.scannerSufffix.invalid && prefixSuffixForm.controls.scannerSufffix.dirty">
                <div class="invalid-feedback"
                    *ngIf="prefixSuffixForm.controls.scannerSufffix.invalid && prefixSuffixForm.controls.scannerSufffix.dirty"
                    id="scannerSufffix-validation">
                    <small
                        *ngIf="prefixSuffixForm.controls.scannerSufffix.errors?.onlyWhiteSpace">{{resourceKeyValue.onlyWhiteSpaceNotAllowed}}</small>
                    <small
                        *ngIf="prefixSuffixForm.controls.scannerSufffix.errors.maxlength">{{resourceKeyValue.validationLengthMustbe50Characters}}</small>
                    <small
                        *ngIf="prefixSuffixForm.controls.scannerSufffix.errors?.containsWhiteSpace">{{resourceKeyValue.whiteSpaceNotAllowed}}</small>
                </div>
            </div>
        </div>
        <div class="col-md-3">
            <h3 class="mb-3"><strong>{{resourceKeyValue.deviceTitle}}</strong></h3>
            <div class="form-group">
                <label for="devicePrefix">{{resourceKeyValue.prefix}}</label>
                <input type="text" class="form-control" id="devicePrefix"
                    placeholder="{{resourceKeyValue.phDevicePrefix}}" formControlName="devicePrefix"
                    [class.is-invalid]="prefixSuffixForm.controls.devicePrefix.invalid && prefixSuffixForm.controls.devicePrefix.dirty">
                <div class="invalid-feedback"
                    *ngIf="prefixSuffixForm.controls.devicePrefix.invalid && prefixSuffixForm.controls.devicePrefix.dirty"
                    id="devicePrefix-validation">
                    <small
                        *ngIf="prefixSuffixForm.controls.devicePrefix.errors?.onlyWhiteSpace">{{resourceKeyValue.onlyWhiteSpaceNotAllowed}}</small>
                    <small
                        *ngIf="prefixSuffixForm.controls.devicePrefix.errors.maxlength">{{resourceKeyValue.validationLengthMustbe50Characters}}</small>
                    <small
                        *ngIf="prefixSuffixForm.controls.devicePrefix.errors?.containsWhiteSpace">{{resourceKeyValue.whiteSpaceNotAllowed}}</small>
                </div>
            </div>
            <div class="form-group">
                <label for="deviceSufffix">{{resourceKeyValue.suffix}}</label>
                <input type="text" class="form-control" id="deviceSufffix"
                    placeholder="{{resourceKeyValue.phDeviceSuffix}}" formControlName="deviceSufffix"
                    [class.is-invalid]="prefixSuffixForm.controls.deviceSufffix.invalid && prefixSuffixForm.controls.deviceSufffix.dirty">
                <div class="invalid-feedback"
                    *ngIf="prefixSuffixForm.controls.deviceSufffix.invalid && prefixSuffixForm.controls.deviceSufffix.dirty"
                    id="deviceSufffix-validation">
                    <small
                        *ngIf="prefixSuffixForm.controls.deviceSufffix.errors?.onlyWhiteSpace">{{resourceKeyValue.onlyWhiteSpaceNotAllowed}}</small>
                    <small
                        *ngIf="prefixSuffixForm.controls.deviceSufffix.errors.maxlength">{{resourceKeyValue.validationLengthMustbe50Characters}}</small>
                    <small
                        *ngIf="prefixSuffixForm.controls.deviceSufffix.errors?.containsWhiteSpace">{{resourceKeyValue.whiteSpaceNotAllowed}}</small>
                </div>
            </div>
        </div>
        <div class="col-md-3">
            <h3 class="mb-3"><strong>{{resourceKeyValue.patientTitle}}</strong></h3>
            <div class="form-group">
                <label for="patientPrefix">{{resourceKeyValue.prefix}}</label>
                <input type="text" class="form-control" id="patientPrefix"
                    placeholder="{{resourceKeyValue.phPatientPrefix}}" formControlName="patientPrefix"
                    [class.is-invalid]="prefixSuffixForm.controls.patientPrefix.invalid && prefixSuffixForm.controls.patientPrefix.dirty">
                <div class="invalid-feedback"
                    *ngIf="prefixSuffixForm.controls.patientPrefix.invalid && prefixSuffixForm.controls.patientPrefix.dirty"
                    id="patientPrefix-validation">
                    <small
                        *ngIf="prefixSuffixForm.controls.patientPrefix.errors?.onlyWhiteSpace">{{resourceKeyValue.onlyWhiteSpaceNotAllowed}}</small>
                    <small
                        *ngIf="prefixSuffixForm.controls.patientPrefix.errors.maxlength">{{resourceKeyValue.validationLengthMustbe50Characters}}</small>
                    <small
                        *ngIf="prefixSuffixForm.controls.patientPrefix.errors?.containsWhiteSpace">{{resourceKeyValue.whiteSpaceNotAllowed}}</small>
                </div>
            </div>
            <div class="form-group">
                <label for="patientSufffix">{{resourceKeyValue.suffix}}</label>
                <input type="text" class="form-control" id="patientSufffix"
                    placeholder="{{resourceKeyValue.phPatientSuffix}}" formControlName="patientSufffix"
                    [class.is-invalid]="prefixSuffixForm.controls.patientSufffix.invalid && prefixSuffixForm.controls.patientSufffix.dirty">
                <div class="invalid-feedback"
                    *ngIf="prefixSuffixForm.controls.patientSufffix.invalid && prefixSuffixForm.controls.patientSufffix.dirty"
                    id="patientSufffix-validation">
                    <small
                        *ngIf="prefixSuffixForm.controls.patientSufffix.errors?.onlyWhiteSpace">{{resourceKeyValue.onlyWhiteSpaceNotAllowed}}</small>
                    <small
                        *ngIf="prefixSuffixForm.controls.patientSufffix.errors.maxlength">{{resourceKeyValue.validationLengthMustbe50Characters}}</small>
                    <small
                        *ngIf="prefixSuffixForm.controls.patientSufffix.errors?.containsWhiteSpace">{{resourceKeyValue.whiteSpaceNotAllowed}}</small>
                </div>
            </div>
            <div class="form-group">
                <label for="patientSearchDelimeter">{{resourceKeyValue.searchDelimiter}}</label>
                <input type="text" class="form-control" id="patientSearchDelimeter"
                    placeholder="{{resourceKeyValue.phPatientSearchDelimiter}}" formControlName="patientSearchDelimeter"
                    [class.is-invalid]="prefixSuffixForm.controls.patientSearchDelimeter.invalid && prefixSuffixForm.controls.patientSearchDelimeter.dirty">
                <div class="invalid-feedback"
                    *ngIf="prefixSuffixForm.controls.patientSearchDelimeter.invalid && prefixSuffixForm.controls.patientSearchDelimeter.dirty"
                    id="patientSearchDelimeter-validation">
                    <small
                        *ngIf="prefixSuffixForm.controls.patientSearchDelimeter.errors?.onlyWhiteSpace">{{resourceKeyValue.onlyWhiteSpaceNotAllowed}}</small>
                    <small
                        *ngIf="prefixSuffixForm.controls.patientSearchDelimeter.errors.maxlength">{{resourceKeyValue.validationLengthMustbe50Characters}}</small>
                    <small
                        *ngIf="prefixSuffixForm.controls.patientSearchDelimeter.errors?.containsWhiteSpace">{{resourceKeyValue.whiteSpaceNotAllowed}}</small>
                </div>
            </div>
        </div>
        <div class="col-md-12 mt-3 border-top border-bottom p-3 bg-light">
            <div class="form-group w-25">
                <label for="formControlFacilities">{{resourceKeyValue.selectFacility}}</label>
                <mat-select #select id="formControlFacilities" [formControl]="formControlFacilities"
                    formControlName="formControlFacilities" multiple>
                    <mat-select-trigger>{{selectedValueText}}</mat-select-trigger>
                    <mat-option #allSelected [value]="allSelectedValue" (click)="toggleAllSelection(select)">
                        {{allSelectedValue.name}}
                    </mat-option>
                    <mat-option *ngFor="let facility of facilities" [value]="facility"
                        [disabled]="facility.id === currentSelectedFacilityID"
                        (click)="togglePerOne(allSelected, select)">{{facility.name}}</mat-option>
                </mat-select>
            </div>
        </div>
    </form>

    <div class="form-button-fixed">
        <button id="cancelPrefixSuffixBtn" class="btn btn-secondary" [routerLink]="['/idns']">
            {{resourceKeyValue.cancel}}
        </button>
        <button id="createPrefixSuffixBtn" type="submit" class="btn btn-primary ml-3" form="prefixSuffixForm"
            [disabled]="isLoading || !prefixSuffixForm.valid || (prefixSuffixForm.valid && prefixSuffixForm.pristine)">
            {{resourceKeyValue.save}}
        </button>
    </div>
</div>
<div *ngIf="!isFacilityConfigured && !isLoading" class=" container-fluid mt-5 pt-5">
    <div class="row">
        <div class="col">
            <h1 id="notAuthorizedInstruction1-Label">{{lblNotAuthorizedInstruction1}}</h1>
        </div>
    </div>
    <div class="row">
        <div class="col">
            <h3 id="notAuthorizedInstruction2-Label">{{lblNotAuthorizedInstruction2}}</h3>
        </div>
    </div>
</div>
<app-loader [isLoading]=isLoading></app-loader>